class ToastService {
  constructor() {
    this.listeners = new Set();
    this.counter = 0;
  }
  subscribe(fn) { this.listeners.add(fn); return () => this.listeners.delete(fn); }
  push(message, level = 'error', ttlMs = 3500) {
    const id = ++this.counter;
    const toast = { id, message, level };
    for (const fn of this.listeners) { try { fn({ type: 'add', toast }); } catch {} }
    setTimeout(() => {
      for (const fn of this.listeners) { try { fn({ type: 'remove', id }); } catch {} }
    }, ttlMs);
  }
}

export default new ToastService();

